import * as React from "react";

import { Card, H1 } from "@blueprintjs/core";
import { css } from "glamor";

import { Link } from "react-router-dom";

const styles = {
	container: css({ width: "100%", textAlign: "left" }),
	table: css({ width: "100%" }),
	mobileMargin: css({
		"@media (max-width: 780px)": {
			marginLeft: "20px",
			marginRight: "20px",
		},
	}),
};

interface Props {
	dark: boolean;
}

export default class Ranking extends React.Component<Props> {
	public render() {
		return (
			<div {...styles.mobileMargin}>
				<Card {...styles.container}>
					<H1>Rankings</H1>
					<Link to={"/ranking/" + 1}>
						<div>Round 1</div>
					</Link>
					<Link to={"/ranking/" + 2}>
						<div>Round 2</div>
					</Link>
					<Link to={"/ranking/" + 3}>
						<div>Round 3</div>
					</Link>
					<Link to={"/ranking/" + 4}>
						<div>Final</div>
					</Link>
				</Card>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Public/RankingSelector.tsx